import type { Ref } from "vue";
import { onMounted } from "vue";

import { useNativeEvents } from "@/composables/useNativeEvents";
import { isEqual } from "@/math/coordinates";
import type { ViewportCoordinate } from "@/model/coordinates";
import { scrollPos } from "@/utils/dom/coordinates";
import { isLinkDrag } from "@/utils/dom/dom";
import { nonMovedPointer, mouseState } from "@/utils/dom/pointer";

import { isPinching } from "./pinch";

export function useLongClick(
  el: Ref<HTMLElement | null>,
  longClick: number,
  handler: (param: { element: HTMLElement; pos: ViewportCoordinate }) => void,
) {
  const { addEventListener } = useNativeEvents();

  onMounted(() => {
    const element = el.value!; //assume el is not null in onMounted
    addEventListener(element, "pointerdown", (e: PointerEvent) => {
      if (isLinkDrag(e)) return;

      const scrollBefore = scrollPos();
      const mouse = mouseState();

      window.setTimeout(() => {
        const noScroll = isEqual(scrollPos(), scrollBefore, 1);
        const noClick = e.pointerType !== "mouse" || mouse.isButtonDownOnce();
        const pointer = nonMovedPointer(e);
        if (pointer && noScroll && noClick && !isPinching(e.pointerId)) {
          handler({ element, pos: pointer.pos });
        }
      }, longClick);
    });
  });
}
